import React from "react";

const InputError = ({error}) => {
    return (
        <p className="text-red-500 text-sm mt-[2px] whitespace-pre-wrap">{error}</p>
    );
};

export default InputError;